// Google Ads Conversion Tracking Utility

/**
 * Track form submission conversion
 * Call this when a user submits the contact form
 */
export const trackFormSubmission = () => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-17896996623/oi9RCL6kwesbEI_--dVC',
      'transaction_id': `form_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
    });
    console.log('Form submission conversion tracked');
  }
};

/**
 * Track phone call click conversion
 * Call this when a user clicks any "Call Now" button
 */
export const trackPhoneClick = () => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-17896996623/oi9RCL6kwesbEI_--dVC',
      'transaction_id': `call_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
    });
    console.log('Phone click conversion tracked');
  }
};

/**
 * Track general conversion with custom transaction ID
 */
export const trackConversion = (type = 'general') => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-17896996623/oi9RCL6kwesbEI_--dVC',
      'transaction_id': `${type}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
    });
    console.log(`${type} conversion tracked`);
  }
};
